function importAll(r) {
  let images = {};
  r.keys().map(item => { images[item.replace('./', '')] = r(item); 
  return r;
});
  return images;
}

const preview = importAll(require.context('./Stores', false, /\.(png|jpe?g|svg)$/));

export const stores = {
  '/ozon': {
    title:`Ozon`,
    preview1: preview['ozon.png'],
    preview2: preview['ozon.png'],
    link: "https://www.ozon.ru/seller/fromthemoon-92372"
  },
  '/wildberries': {
    title:`Wildberries`,
    preview1: preview['wildberries.png'],
    preview2: preview['wildberries.png'],
    link: "https://www.wildberries.ru/seller/129940"
  },
  '/ga': {
    title:`Золотое яблоко`,
    preview1: preview['gold_apple.png'],
    preview2: preview['gold_apple.png'],
    link: "https://goldapple.ru/brands/fromthemoon"
  },
  '/letoile': {
    title:`Лэтуаль`,
    preview1: preview['letoile.png'],
    preview2: preview['letoile.png'],
    link: "https://www.letu.ru/brand/fromthemoon"
  },
    '/letoile': {
    title:`Лэтуаль`,
    preview1: preview['letoile.png'],
    preview2: preview['letoile.png'],
    link: "https://www.letu.ru/brand/fromthemoon"
  },
  '/yandexmarket': {
    title:`Яндекс.Маркет`,
    preview1: preview['ya_market.png'],
    preview2: preview['ya_market.png'],
    link: "https://market.yandex.ru/business--fromthemoon/768163"
  }
}